import { AbstractControl, ValidationErrors } from '@angular/forms';
import { AT_LEAST_ONE_REQUIRED_VALIDATION } from '../../../service/model/common/validators';

/**
 * Requires at least one of flightCategories or intracity to be set. Neither control has any other
 * validators in this mode, so it's safe to just set/clear the error directly on both.
 */
export const atLeastOneJourneyFieldRequired = (control: AbstractControl): ValidationErrors | null => {
  const flightCategories = control.get('flightCategories');
  const intracity = control.get('intracity');

  const hasValue = (flightCategories?.value?.length ?? 0) > 0 || intracity?.value === true;
  const error = hasValue ? null : { [AT_LEAST_ONE_REQUIRED_VALIDATION]: true };

  flightCategories?.setErrors(error, { emitEvent: false });
  intracity?.setErrors(error, { emitEvent: false });

  return null;
};
